import { Box, Chip, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { STAGES } from '../constants';

export default function StageHeader({ stage, onOpenHelp }) {
  const flowMode = useSelector((st) => st.tatWizard.flowMode);
  const s = STAGES[stage];
  if (!s) return null;
  // Stage 1's title is contextual — matches the stepper's "Merchant Selected" pill
  // and the "Loaded TATs for …" card in the existing/update flow.
  const existingStage0 = stage === 0 && flowMode === 'existing';
  const title = existingStage0 ? 'Merchant Selected' : s.label;
  const explainer = existingStage0
    ? 'Existing merchant loaded — their current TAT master is pulled from ProShip and prefilled into the editor for you to amend.'
    : s.explainer;
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        boxShadow: (t) => t.customShadows?.z1 || 1,
        p: 2.5,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <Chip
          label={`Stage ${stage + 1} of ${STAGES.length}`}
          size="small"
          sx={{
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            fontWeight: 800,
            fontSize: 10.5,
            letterSpacing: 0.5,
            textTransform: 'uppercase',
            height: 24,
          }}
        />
        <Typography variant="h5" sx={{ fontSize: 21, m: 0, letterSpacing: '-.2px' }}>
          {title}
        </Typography>
      </Stack>
      <Typography variant="body2" sx={{ mt: 0.75, color: 'text.secondary', maxWidth: 880 }}>
        {explainer}
      </Typography>
    </Box>
  );
}
